import PublicLayout from './PublicLayout';

const layouts = {
    public: PublicLayout,
};

export type LayoutKey = keyof typeof layouts;

export default layouts;
